import React, { memo } from 'react'
import imageIcon from 'img/image.svg'
import refreshBlueIcon from 'img/refresh-blue.svg'
import { Question } from 'types'

export const EditActionRow = memo(({ setShowFeedback, onEdit, onAddImage }: { setShowFeedback: (showFeedback: boolean) => void, onEdit: (payload: Partial<Question>) => void, onAddImage?: () => void }) => {

    return (
        <>
            <div className="editor-actions-row">
                <button className="editor-action-button" onClick={() => onAddImage && onAddImage()}>
                    <img src={imageIcon} alt="add image" />
                    Add Image
                </button>
                <button className="editor-action-button" onClick={() => setShowFeedback(true)}>
                    <img
                        src={refreshBlueIcon}
                        alt="refresh"
                        className="editor-action-icon"
                    />
                    Get new question
                </button>
            </div>
        </>
    )
})

export default EditActionRow


